module.exports = __webpack_public_path__ + "static/zqb_3.af639537.jpg";